<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Instalador PDV" style="margin-right: 10px;" @click.prevent="mtdbaixarinstaladorpdv()"><span aria-hidden="true"><i class="fa fa-download"></i></span></button>                                     -->
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstpdvs"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                                               
                                    <template slot="slot_opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)" title="Alterar"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)" title="Excluir"><i class="fa fa-trash"></i></button>
                                        <button type="button" class="btn btn-success btn-sm btn-opcrud ajt-btn" @click.prevent="mtdclonar(item.row)" title="Clonar pdv"><i class="fa fa-copy"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstpdvs.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-3">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-1">
                                <label for="edserie">*Série:</label>
                                <input type="number" v-model="vserie" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edserie" maxlength="3">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edserie">*Sequência NFC-e:</label>
                                <input type="number" v-model="vnnf" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edserie" maxlength="11">
                            </div>
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cblayoutbalança">Layou balança:</label>
                                <select name="cblayoutbalanca" class="form-control form-control-sm" id="cblayoutbalanca" v-model="vlayoutbalanca" v-bind:disabled="ativadesativa">
                                    <option value="0">Valor</option>
                                    <option value="1">Quantidade</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddigitosbalanca">*Dígitos balança:</label>
                                <input type="number" v-model="vdigitosbalanca" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eddigitosbalanca" maxlength="2">
                            </div>
                            <!-- <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cboffline">Off-line:</label>
                                <select name="cboffline" class="form-control form-control-sm" id="cboffline" v-model="voffline" v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div> -->
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cboffline">Ativar senha Seq:</label>
                                <select name="cboffline" class="form-control form-control-sm" id="cboffline" v-model="vativarsenhasequencial" v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>  
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edfatordiferenca">Fator diferença:</label>
                                <money type="text" class="form-control form-control-sm" id="edicms" v-model="vfatordiferenca"
                                        v-bind="money" v-bind:disabled="ativadesativa" data-bv-group=".group" style="text-align:right;"
                                        title="Informe o valor mínimo para identificação de diferença do caixa"></money>
                            </div>                                                                                                                                           
                            <div class="col-md-2" style="padding-top: 25px;">
                                <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                    <input type="checkbox" class="custom-control-input" id="swcpadraonfce" name="swcpadraonfce" v-model="vpadraonfce" v-bind:disabled="ativadesativa">
                                    <label class="custom-control-label" for="swcpadraonfce">NFC-e padrão</label>
                                </div>						                                
                            </div>
                        </div>
                        <div class="row" style="margin-top: 15px;">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header card-in text-center">INTEGRAÇÃO COM O FLUXO DE CAIXA</div>
                                    <div class="card-body">
                                        <div class="row">                                                                                      
                                            <div class="col-md-3" style="padding-top: 25px;">
                                                <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                    <input type="checkbox" class="custom-control-input" id="swclancamentosindividuaisfluxo" name="swclancamentosindividuaisfluxo" v-model="vlancamentosindividuaisfluxo" v-bind:disabled="ativadesativa">
                                                    <label class="custom-control-label" for="swclancamentosindividuaisfluxo">Lançamentos individuais</label>
                                                </div>						                                
                                            </div>                                            
                                            <div class="col-md-3">
                                                <span class="lblselect2">Perfil fluxo(Aberturas):</span>
                                                <select id="cbperfilfluxoaberturas" v-model="vidperfilfluxoaberturas" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                                </select>
                                            </div>                                            
                                            <div class="col-md-3">
                                                <span class="lblselect2">Perfil fluxo(Entradas):</span>
                                                <select id="cbperfilfluxoentradas" v-model="vidperfilfluxoentradas" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                                </select>
                                            </div>				  
                                            <div class="col-md-3">
                                                <span class="lblselect2">Perfil fluxo(Saídas):</span>
                                                <select id="cbperfilfluxosaidas" v-model="vidperfilfluxosaidas" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                                </select>
                                            </div>				                                                                         
                                        </div>
                                        <div class="row" style="margin-top: 15px;">
                                            <div class="col-md-6">
                                                <div class="card">
                                                    <div class="card-header card-in text-center">INTEGRAÇÃO DE VENDAS</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-md-5">
                                                                <span class="lblselect2">Forma:</span>
                                                                <select id="cbformadefvendas" v-model="vidformadefvendas" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                                                </select>
                                                            </div>				  
                                                            <div class="col-md-5">
                                                                <span class="lblselect2">Perfil:</span>
                                                                <select id="cbperfilfluxodefvendas" v-model="vidperfilfluxodefvendas" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                                                </select>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <button type="button" id="btincformadefvendas" class="btn btn-info btn-sm"
                                                                        @click.prevent="mtdincformavenda()" v-bind:disabled="ativadesativa"
                                                                        style="width:100%; margin-top: 21px;"><i class="fa fa-plus-circle"></i>                                                                    
                                                                </button>
                                                            </div>                                                            				                                              
                                                        </div>
                                                        <div class="row">
                                                            <div v-if="lstperfisformasvendas.length > 0" class="col-lg-12">
                                                                <div class="table-responsive">
                                                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                        <tr>
                                                                            <th>Forma:</th>
                                                                            <th>Perfil:</th>
                                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody id="lstperfisformasvendas">
                                                                            <tr v-for="(item, index) in lstperfisformasvendas" v-bind:key="index">
                                                                                <td>{{ item.descforma }}</td>
                                                                                <td>{{ item.descperfilfluxo }}</td>                                  
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtdexcluirformavenda(index)"><i class="fa fa-trash"></i></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>                                                            
                                                        </div>
                                                    </div>
                                                </div>                                
                                            </div>
                                            <div class="col-md-6">
                                                <div class="card">
                                                    <div class="card-header card-in text-center">INTEGRAÇÃO DE RECEBIMENTOS(CR)</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-md-5">
                                                                <span class="lblselect2">Forma:</span>
                                                                <select id="cbformadefreceitas" v-model="vidformadefreceitas" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                                                </select>
                                                            </div>				  
                                                            <div class="col-md-5">
                                                                <span class="lblselect2">Perfil:</span>
                                                                <select id="cbperfilfluxodefreceitas" v-model="vidperfilfluxodefreceitas" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                                                </select>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <button type="button" id="btincformadefreceitas" class="btn btn-info btn-sm"
                                                                        @click.prevent="mtdincluirformareceita()" v-bind:disabled="ativadesativa"
                                                                        style="width:100%; margin-top: 21px;"><i class="fa fa-plus-circle"></i>                                                                    
                                                                </button>
                                                            </div>                                                            				                                              
                                                        </div>
                                                        <div class="row">
                                                            <div v-if="lstperfisformasreceitas.length > 0" class="col-lg-12">
                                                                <div class="table-responsive">
                                                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                        <tr>
                                                                            <th>Forma:</th>
                                                                            <th>Perfil:</th>
                                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody id="lstperfisformasreceitas">
                                                                            <tr v-for="(item, index) in lstperfisformasreceitas" v-bind:key="index">
                                                                                <td>{{ item.descforma }}</td>
                                                                                <td>{{ item.descperfilfluxo }}</td>                                  
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtdexcluirformareceita(index)"><i class="fa fa-trash"></i></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>                                                            
                                                        </div>
                                                    </div>
                                                </div>                                
                                            </div>                                                                                                                                    
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadinformacoescomplementares',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstpdvs  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                vidfilial           : null,
                vserie              : 1,
                vnnf                : 1,
                vlayoutbalanca      : 0,// 0 - Valor, 1 - Quantidade,
                vdigitosbalanca     : 6,
                vpadraonfce         : false,
                voffline            : 0,                
                vativarsenhasequencial       : 0,
                vfatordiferenca     : 0,
                vlancamentosindividuaisfluxo : false,
                vidperfilfluxoaberturas  : null,
                vidperfilfluxoentradas   : null,
                vidperfilfluxosaidas     : null,
                vidperfilfluxodefvendas  : null,
                vidperfilfluxodefreceitas: null,
                vidformadefvendas        : null,
                vidformadefreceitas      : null,
                lstperfisformasvendas    : [],
                lstperfisformasreceitas  : [],

                //variável para habilitação dos campos
                ativadesativa       : true,                              
                money: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'PONTOS DE VENDA',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",                        
                        slot_name: "slot_opcoes",
                        row_classes: "def-col-opcoes-cadpdv",                        
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Filial",
                        name: "fantasia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Série(NFC-e)",
                        name: "serie",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Número(NFC-e)",
                        name: "nnf",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{           
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and p.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(p.descricao) like upper("'+this.pconteudo+'%")';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpdvs.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregapdvs(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregapdvs(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpdvs.php');
                retorno.then(function (response) {
                    vself.lstpdvs = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstpdvs = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                = '';
                this.vdescricao         = '';
                this.vidfilial          = null;
                this.vserie             = 1;
                this.vnnf               = 1;
                this.vlayoutbalanca     = 0;
                this.vdigitosbalanca    = 6;
                this.vpadraonfce        = false;
                this.voffline           = 0;
                this.vativarsenhasequencial       = 0;
                this.vfatordiferenca              = 0;
                this.vlancamentosindividuaisfluxo = false;
                this.vidperfilfluxoaberturas  = null;
                this.vidperfilfluxoentradas   = null;
                this.vidperfilfluxosaidas     = null;
                this.vidformadefvendas        = null;
                this.vidformadefreceitas      = null;                
                this.vidperfilfluxodefvendas  = null;
                this.vidperfilfluxodefreceitas= null;                
                this.lstperfisformasvendas    = [];
                this.lstperfisformasreceitas  = [];

                $("#cbfilial").val(null).trigger('change');
                $("#cbperfilfluxoaberturas").val(null).trigger('change');
                $("#cbperfilfluxoentradas").val(null).trigger('change');
                $("#cbperfilfluxosaidas").val(null).trigger('change');
                $("#cbperfilfluxodefvendas").val(null).trigger('change');
                $("#cbperfilfluxodefreceitas").val(null).trigger('change');                
                $("#cbformadefvendas").val(null).trigger('change');
                $("#cbformadefreceitas").val(null).trigger('change');
                $("#cbformadefvendas").val(null).trigger('change');
                $("#cbformadefreceitas").val(null).trigger('change');                
            },
            mtdselect2_def(){
                let vself = this;

				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';
                                
				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
				});
				
				$("#cbperfilfluxoaberturas").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidperfilfluxoaberturas = $("#cbperfilfluxoaberturas").val();
                });                
                $("#cbperfilfluxoentradas").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidperfilfluxoentradas = $("#cbperfilfluxoentradas").val();
                });                                
				$("#cbperfilfluxosaidas").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidperfilfluxosaidas = $("#cbperfilfluxosaidas").val();
                });                                                
				$("#cbperfilfluxodefvendas").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidperfilfluxodefvendas = $("#cbperfilfluxodefvendas").val();
                });                                
				$("#cbperfilfluxodefreceitas").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidperfilfluxodefreceitas = $("#cbperfilfluxodefreceitas").val();
                });                        
                $("#cbformadefvendas").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbformaspagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidformadefvendas = $("#cbformadefvendas").val();
                });
                $("#cbformadefreceitas").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbformaspagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidformadefreceitas = $("#cbformadefreceitas").val();
                });                
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.020M.001Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PONTO DE VENDA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstpdvs = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpdvs.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.020M.005Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE PONTOS DE VENDA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.020M.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE PONTO DE VENDA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdclonar(item){
                if (!util.opcaousuario('002Z.020M.001Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PONTO DE VENDA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.mtdlocalizaregistro(item.id);                                        
                }
            },
            mtdigualarcampos(registro){
                if (parseInt(this.opcrud) === 1){
                    this.vid                = '';
                }else{
                    this.vid                = registro.id;
                }
                this.vdescricao             = registro.descricao;
                this.vidfilial              = registro.idfilial;
                this.vserie                 = registro.serie;
                this.vnnf                   = registro.nnf;
                this.vlayoutbalanca         = registro.layoutbalanca;
                this.vdigitosbalanca        = registro.digitosbalanca;
                this.vpadraonfce            = parseInt(registro.padraonfce) === 0 ? false : true;
                this.voffline               = registro.offline;
                this.vativarsenhasequencial = registro.ativarsenhasequencial;   
                this.vfatordiferenca        = registro.fatordiferenca;
                this.lstperfisformasvendas  = registro.formasvendas;
                this.lstperfisformasreceitas= registro.formasrec;
                this.vlancamentosindividuaisfluxo = parseInt(registro.lancamentosindividuaisfluxo) === 0 ? false : true;

                var deffilial  = new Option(registro.fantasia, registro.idfilial, true, true);                
				$('#cbfilial').append(deffilial).trigger('change');                

                this.vidperfilfluxoaberturas = parseInt(registro.idperfilfluxoaberturas) === 0 ? null : registro.idperfilfluxoaberturas;                
                if (this.vidperfilfluxoaberturas !== null){                                    
                    var defperfilfluxoaberturas  = new Option(registro.descfluxoaberturas, registro.idperfilfluxoaberturas, true, true);
				    $('#cbperfilfluxoaberturas').append(defperfilfluxoaberturas).trigger('change');                
                }else{
                    $("#cbperfilfluxoaberturas").val(null).trigger('change');
                }

                this.vidperfilfluxoentradas = parseInt(registro.idperfilfluxoentradas) === 0 ? null : registro.idperfilfluxoentradas;                
                if (this.vidperfilfluxoentradas !== null){                                    
                    var defperfilfluxoentradas  = new Option(registro.descfluxoentradas, registro.idperfilfluxoentradas, true, true);
				    $('#cbperfilfluxoentradas').append(defperfilfluxoentradas).trigger('change');                
                }else{
                    $("#cbperfilfluxoentradas").val(null).trigger('change');
                }

                this.vidperfilfluxosaidas   = parseInt(registro.idperfilfluxosaidas)   === 0 ? null : registro.idperfilfluxosaidas;
                if (this.vidperfilfluxosaidas !== null){                    
                    var deffilfluxosaidas  = new Option(registro.descfluxosaidas, registro.idperfilfluxosaidas, true, true);
                    $('#cbperfilfluxosaidas').append(deffilfluxosaidas).trigger('change');                
                }else{
                    $("#cbperfilfluxosaidas").val(null).trigger('change');
                }
                            
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'idfilial'          : this.vidfilial,
                    'serie'             : this.vserie,
                    'nnf'               : this.vnnf,
                    'layoutbalanca'     : this.vlayoutbalanca,
                    'digitosbalanca'    : this.vdigitosbalanca,
                    'padraonfce'        : this.vpadraonfce === false ? 0 : 1,
                    'offline'           : this.voffline,
                    'ativarsenhasequencial'         : this.vativarsenhasequencial,
                    'fatordiferenca'                : this.vfatordiferenca,    
                    'lancamentosindividuaisfluxo'   : this.vlancamentosindividuaisfluxo === false ? 0 : 1,
                    'idperfilfluxoaberturas': this.vidperfilfluxoaberturas=== null ? 0 : this.vidperfilfluxoaberturas,
                    'idperfilfluxoentradas' : this.vidperfilfluxoentradas === null ? 0 : this.vidperfilfluxoentradas,
                    'idperfilfluxosaidas'   : this.vidperfilfluxosaidas   === null ? 0 : this.vidperfilfluxosaidas,
                    'formasvendas'          : this.lstperfisformasvendas,
                    'formasrec'             : this.lstperfisformasreceitas
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '002Z.020M.001Z' : parseInt(this.opcrud) === 2 ? '002Z.020M.005Z' : '002Z.020M.010Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpdvs.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapdvs(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdbaixarinstaladorpdv(){
                window.open('https://www.rillsoft-app.cloud/arquivos/manager/programas/instaladopdvrillsoft.exe', '_blank');                
            },
            mtdincformavenda(){
                if (this.vidformadefvendas === null){
                    this.$toastr.w('Forma de pagamento deve ser informada!', 'Atenção!');
                    $('#cbformadefvendas').select2('open');
                    return;
                }
                if (this.vidperfilfluxodefvendas === null){
                    this.$toastr.w('Perfil do fluxo deve ser informado!', 'Atenção!');
                    $('#cbperfilfluxodefvendas').select2('open');
                    return;
                }
                if (!util.findValInArray(this.lstperfisformasvendas, 'idforma', this.vidformadefvendas)) {
                    let itemtmp = {
                        'idforma'        : this.vidformadefvendas,
                        'descforma'      : $('#cbformadefvendas').select2('data')[0]['text'],
                        'idperfilfluxo'  : this.vidperfilfluxodefvendas,
                        'descperfilfluxo': $('#cbperfilfluxodefvendas').select2('data')[0]['text']
                    }                
                    this.lstperfisformasvendas.push(itemtmp);
                    this.vidformadefvendas       = null;
                    this.vidperfilfluxodefvendas = null;               
                    $("#cbformadefvendas").val(null).trigger('change');                
                    $("#cbperfilfluxodefvendas").val(null).trigger('change');
                    $('#cbformadefvendas').select2('open');
                }else{
                    this.$toastr.w('A forma selecionada já está com perfil de fluxo definido!', 'Atenção!');
                    $('#cbformadefvendas').select2('open');                    
                }
            },
            mtdexcluirformavenda(indice){
                if (parseInt(this.opcrud) < 3){
                    this.lstperfisformasvendas.splice(indice, 1);
                }
            },
            mtdincluirformareceita(){
                if (this.vidformadefreceitas === null){
                    this.$toastr.w('Forma de pagamento deve ser informada!', 'Atenção!');
                    $('#cbformadefreceitas').select2('open');
                    return;
                }
                if (this.vidperfilfluxodefreceitas === null){
                    this.$toastr.w('Perfil do fluxo deve ser informado!', 'Atenção!');
                    $('#cbperfilfluxodefreceitas').select2('open');
                    return;
                }
                if (!util.findValInArray(this.lstperfisformasreceitas, 'idforma', this.vidformadefreceitas)) {
                    let itemtmp = {
                        'idforma'        : this.vidformadefreceitas,
                        'descforma'      : $('#cbformadefreceitas').select2('data')[0]['text'],
                        'idperfilfluxo'  : this.vidperfilfluxodefreceitas,
                        'descperfilfluxo': $('#cbperfilfluxodefreceitas').select2('data')[0]['text']
                    }                
                    this.lstperfisformasreceitas.push(itemtmp);
                    this.vidformadefreceitas       = null;
                    this.vidperfilfluxodefreceitas = null;               
                    $("#cbformadefreceitas").val(null).trigger('change');                
                    $("#cbperfilfluxodefreceitas").val(null).trigger('change');
                    $('#cbformadefreceitas').select2('open');
                }else{
                    this.$toastr.w('A forma selecionada já está com perfil de fluxo definido!', 'Atenção!');
                    $('#cbformadefreceitas').select2('open');                    
                }
            },
            mtdexcluirformareceita(indice){
                if (parseInt(this.opcrud) < 3){
                    this.lstperfisformasreceitas.splice(indice, 1);
                }
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.020M', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdselect2_def();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.vconteudo === '' || this.vidfilial === null || 
                this.vserie === '' || this.vdigitosbalanca <= 0 || this.vnnf === '';
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregapdvs(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-opcoes-cadpdv{
        width: 130px !important;
    }
    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }

</style>